export default {
    apiBaseUrl: process.env.REACT_APP_MASTER_API_BASE_URL,
    customerBaseUrl: process.env.REACT_APP_CUSTOMER_API_BASE_URL,
    updatesBaseUrl: process.env.REACT_APP_UPDATES_API_BASE_URL,
    log: false,
    trackHttpTimeInConsole: false, // Works when log is true
    trackHttpResponseInConsole: false, // Works when log is true,
    graphExplorerBaseUrl: 'https://graph.microsoft.com'
};


  